<template lang="html">
  <div class="main">
    <div class="door" v-show="doorType !==''">
      <div class="alarm-body" v-if="filesAlarm.show">
        <div class="alarm">
          <div class="cell" style="line-height:25px;height:auto;">
            {{message.Al208.l0}}{{filesAlarm.num}}{{message.Al208.l1}}
          </div>
          <div class="cell">
            <el-button size="mini" @click="filesAlarm.show=false">{{message.Fl101}}</el-button>
            <el-button size="mini" @click="buildDoor" type="primary">{{message.Fl100}}</el-button>
          </div>
        </div>
      </div>
      <div class="tr">
        <span>{{message.Al184}}</span>
        <span class="set">
          <el-input v-model.trim="set.name" size="mini" style="width:173px"></el-input>
        </span>
      </div>
      <div class="tr">
        <span>{{message.Sl161}}</span>
        <span class="set">
           <el-select  @change="changeWorkspace" size="mini" v-model="set.workspace" placeholder="">
             <el-option
              v-for="item in workspaces"
              :key="item.value"
              :label="item.label"
              :value="item.value"
             >
             </el-option>
           </el-select>
        </span>
      </div>
      <div class="tr">
        <span>{{message.Fl114}}</span>
        <span class="set">
          <el-select
            size="mini"
            multiple
            v-model="set.receivers"
            placeholder=""
            :loading="receiversLoading"
            :disabled="isDisabled"
          >
            <el-option
             v-for="item in receivers"
             :key="item.value"
             :label="item.label"
             :value="item.value"
            >
            </el-option>
          </el-select>
        </span>
      </div>
      <div class="tr" v-if="saveMode===2 && can_archive">
        <el-checkbox
          v-model="isArchive"
          style="font-weight:400;margin:0px auto 5px 140px;color:#212121">
          {{message.Al230}}
        </el-checkbox>
      </div>
      <div class="tr">
        <span>{{message.Al185}}</span>
        <span class="set">
          <el-switch
            size="mini"
            v-model="set.file"
            :active-text="message.Al190"
            :inactive-text="message.Al191">
          </el-switch>
        </span>
      </div>
      <div class="tr">
        <span>{{message.Al186}}</span>
        <span class="set">
          <el-switch
            v-model="set.status"
            :active-text="message.Al188"
            :inactive-text="message.Al189">
          </el-switch>
        </span>
      </div>
      <div class="tr">
        <span>{{message.Al187}}</span>
        <span class="set">
          <div v-if="doorType==='new'">
            <div class="door-path" :title="set.path">{{set.path}}</div> <i class="material-icons open" @click="openPath">folder_open</i>
          </div>
          <div v-if="doorType==='set'">
            <div class="door-path" :title="set.path">{{set.path}}</div>
          </div>
        </span>
      </div>
      <div class="tr" style="text-align:center;padding-top: 15px;">
        <el-button size="mini" @click="submit" :disabled="submitUnShow" type="primary">&nbsp;{{message.Al210}}&nbsp;</el-button>
        <el-button size="mini" @click="doorType=''">{{message.Fl101}}</el-button>
      </div>
    </div>
    <div class="name-title">
      <div class="title">{{message.Al192}} ({{doors.length}}/6)</div>
    </div>
    <VuePerfectScrollbar @settings="settings" class="box">
      <el-button type="primary" size="small" class="add-door" v-if="doors !== null && doors.length < 6" @click="newDoor">
        {{message.Al193}}
      </el-button >
      <div class="cell-main">
        <div class="cell title">
          <div class="name">{{message.Al184}}</div>
          <div class="workspace">{{message.Sl161}}</div>
          <!-- <div class="receivers">接收者</div> -->
          <div class="file" :title="message.Al185">{{message.Al185}}</div>
          <div class="status">{{message.Al186}}</div>
          <div class="path">{{message.Al187}}</div>
        </div>
        <div class="cell" v-for="(item, index) in doors" :key="item.id">
          <div class="name" :title="item.name">
            {{item.name}}
          </div>
          <div class="workspace" :title="item.workspace.name">
            {{item.workspace.name}}
          </div>
          <!-- <div class="receivers">
            {{item.receivers}}
          </div> -->
          <div class="file" :title="item.show">
            <span v-if="item.file">{{message.Al190}}</span><span v-if="!item.file">{{message.Al191}}</span>
          </div>
          <div class="status" :title="item.status">
            <span v-if="item.status">{{message.Al188}}</span><span v-if="!item.status">{{message.Al189}}</span>
          </div>
          <div class="path" :title="item.path">
            {{item.path}}
          </div>
          <div class="operation">
            <i class="material-icons" v-if="index !== 0" @click="moveUp(index)">vertical_align_top</i>
            <i class="material-icons" @click="operation(index)">settings</i>
            <i class="material-icons" @click="deleteDoor(index)">delete</i>
          </div>
          <!-- <div class="other" @click="modify(item.role, 0, item, index)">
            {{item.bps}}
          </div> -->
          <i class="out material-icons" v-if = "item.role !== message.Sl138&& role !== 2" @click="openOut(item.id, item.name, index)">
            block
          </i>
        </div>
      </div>
    </VuePerfectScrollbar>
  </div>
</template>

<script>
import Store from '@/store'
import _this from '@/main'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
export default {
  beforeRouteEnter (to, from, next) {
    if (!Store.state.app.login && Store.state.app.login !== null) {
      _this.$app.login(0, response => {
        if (response === 2) {
          _this.$app.start()
        }
      })
    } else {
      next()
    }
  },
  computed: {
    submitUnShow: function () {
      if (this.set.name && this.set.workspace && this.set.path && this.set.receivers.length) {
        return false
      } else {
        return true
      }
    }
  },
  watch: {
    isArchive: function (val) {
      if (val) {
        this.isDisabled = true
        this.set.receivers = ['archive']
      } else {
        this.isDisabled = false
        this.set.receivers = []
      }
    }
  },
  beforeRouteLeave (to, from, next) {
    if (this.doorType !== '') {
      this.$confirm(this.$lang.ui.notice.l141, this.$lang.ui.system.l133, {
        confirmButtonText: this.$lang.ui.form.l127,
        cancelButtonText: this.$lang.ui.form.l101,
        type: 'warning'
      }).then(() => {
        next()
      }).catch(() => {
        next(false)
      })
    } else {
      next()
    }
  },
  components: {
    VuePerfectScrollbar
  },
  data () {
    return {
      message: {
        Fl100: this.$lang.ui.form.l100,
        Fl101: this.$lang.ui.form.l101,
        Fl114: this.$lang.ui.form.l114,
        Sl161: this.$lang.ui.system.l161,
        Sl190: this.$lang.ui.system.l190,
        Al184: this.$lang.ui.app.l184,
        Al185: this.$lang.ui.app.l185,
        Al186: this.$lang.ui.app.l186,
        Al187: this.$lang.ui.app.l187,
        Al188: this.$lang.ui.app.l188,
        Al189: this.$lang.ui.app.l189,
        Al190: this.$lang.ui.app.l190,
        Al191: this.$lang.ui.app.l191,
        Al192: this.$lang.ui.app.l192,
        Al193: this.$lang.ui.app.l193,
        Al208: this.$lang.ui.app.l208,
        Al210: this.$lang.ui.app.l210,
        Al230: this.$lang.ui.app.l230
      },
      settings: {
        maxScrollbarLength: 0
      },
      doorType: '',
      receiversLoading: false,
      set: {
        name: '',
        workspace: '',
        receivers: [],
        file: false,
        status: false,
        path: ''
      },
      doors: null,
      workspaces: [],
      receivers: [],
      filesAlarm: {
        show: true,
        num: ''
      },
      saveMode: '',
      can_archive: true,
      isDisabled: false,
      isArchive: false,
      }
  },
  mounted () {
    this.getWorkspacesList()
  },
  methods: {
    getTgList () {
      this.$app.tgList(response => {
        this.doors = []
        for (var i = 0; i < response.tglist.length; i++) {
          var data = response.tglist[i]
          var name = ''
          for (var x = 0; x < this.workspaces.length; x++) {
            if (data.projectID === this.workspaces[x].value) {
              name = this.workspaces[x].label
            }
          }
          var li = {
            name: data.tgName,
            workspace: {
              id: data.projectID,
              name: name
            },
            receivers: data.receiverIDs,
            file: data.isShowHiddenFile === 1,
            status: data.enable === 1,
            path: data.tgPath
          }
          this.doors.push(li)
        }
      })
    },
    getWorkspacesList () {
      this.$api.getProjectList(3, response => {
        this.workspaces = []
        for (var i = 0; i < response.projects.length; i++) {
          this.workspaces.push({
            value: response.projects[i].id,
            label: response.projects[i].name
          })
        }
        this.getTgList()
      })
    },
    newDoor () {
      this.filesAlarm.show = false
      this.doorType = 'new'
      this.set.name = ''
      this.set.workspace = ''
      this.set.receivers = []
      this.set.file = false
      this.set.status = false
      this.set.path = ''
      this.receivers = []
      this.saveMode = ''
      this.can_archive = true
      this.isDisabled = false
      this.isArchive = false
    },
    changeWorkspace () {
      this.set.receivers = []
      this.$api.getProject(this.set.workspace, response => {
        this.saveMode = response.project.save_mode
        if (this.saveMode !== 2) {
          this.isDisabled = false
        }
      })
      this.openReceivers()
    },
    openReceivers (callback) {
      this.isArchive = false
      if (this.set.workspace) {
        this.receiversLoading = true
        this.$api.getUsersList(this.set.workspace, response => {
          this.can_archive = response.can_archive
          this.receiversLoading = false
          this.receivers = []
          for (var i = 0; i < response.members.length; i++) {
            this.receivers.push({
              value: response.members[i].user_info.id,
              label: response.members[i].user_info.name
            })
          }
          callback()
        })
      }
    },
    openPath () {
      this.$app.appFolder(response => {
        if (response.selectedFolder !== '') {
          this.set.path = response.selectedFolder
        }
      })
    },
    buildDoor () {
      var e = {
        tgPath: this.set.path,
        tgName: this.set.name,
        projectID: this.set.workspace,
        ownerID: localStorage.getItem('uid'),
        receiverIDs: this.set.receivers,
        isShowHiddenFile: this.set.file ? 1 : 0,
        start: this.set.status ? 1 : 0,
        uploadedOption: 2, // client 默认值为0，但是0功能未实现，强制传2。
      }
      if (this.doorType === 'new') {
        this.$app.buildDoor(e, response => {
          this.doorType = ''
          this.getTgList()
        })
      }
      if (this.doorType === 'set') {
        if (this.set.status) {
          this.$app.startDoor(this.set.path)
        } else {
          this.$app.stopDoor(this.set.path)
        }
        this.$app.setDoor(e, response => {
          this.doorType = ''
          this.getTgList()
        })
      }
    },
    submit () {
      if (this.doorType === 'set' || !this.set.status) {
        this.buildDoor()
        return
      }
      var e = [this.set.path]
      this.$app.getFilesNum(e, response => {
        if (response === 1) {
          this.buildDoor()
        } else {
          if (response.number === 0) {
            this.buildDoor()
          } else {
            this.filesAlarm.show = true
            this.filesAlarm.num = response.number
          }
        }
      })
    },
    operation (i) {
      this.filesAlarm.show = false
      this.set.name = this.doors[i].name
      this.set.workspace = this.doors[i].workspace.id
      this.openReceivers(() => {
        this.set.receivers = this.doors[i].receivers
      })
      this.set.file = this.doors[i].file
      this.set.status = this.doors[i].status
      this.set.path = this.doors[i].path
      this.doorType = 'set'
    },
    deleteDoor (i) {
      this.$confirm(this.$lang.ui.notice.l143, this.$lang.ui.system.l133, {
        confirmButtonText: this.$lang.ui.form.l127,
        cancelButtonText: this.$lang.ui.form.l101,
        type: 'warning'
      }).then(() => {
        var e = {
          tgPath: this.doors[i].path
        }
        this.$app.delDoor(e, response => {
          this.getTgList()
        })
      })
    },
    moveUp (i) {
      var e = {
        operation: 'up',
        tgPath: this.doors[i].path
      }
      this.$app.moveUpDoor(e, response => {
        this.getTgList()
      })
    },
  }
}
</script>

<style scoped lang="css">
.main {
  width: 100%;
  min-width: 800px;
}
.box {
  width: 100%;
  bottom: 15px;
}
.name-title {
  width: 100%;
  height: 50px;
}
.close {
  float: right;
  margin: 11px;
  margin-right: 18px;
  cursor: pointer;
}
.left {
  float: left;
  margin: 11px;
  margin-right: 18px;
  cursor: pointer;
}
.name-title .title {
  display: block;
  height: 100%;
  line-height: 50px;
  float: left;
  margin-left: 20px;
  font-size: 16px;
  font-weight: 600;
}
.box {
  width: 100%;
  bottom: 0;
}
.ticket-more {
  width: 100%;
  padding: 20px;
}
.cell-main {
  background-color: #fff;
  padding: 20px;
}
.bottom-button {
  text-align: right;
  width: 100%;
  padding: 25px;
}
.cell {
  position: relative;
  height: 36px;
  width: 100%;
}
.cell.title {
  font-weight: 600;
  border-bottom: 1px solid #cdcdcd;
  line-height: 30px;
}
.add-door {
  z-index: 2;
  position: absolute;
  right: 35px;
  top: 20px;
}
.name,
.workspace,
.receivers,
.file,
.status,
.path
 {
  display: block;
  text-align: left;
  padding-right: 15px;
  font-size: 14px;
  float: left;
  height: 36px;
  line-height: 36px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.box .name {
  padding-left: 10px;
  width: 160px;
}
.workspace {
  width: 180px;
}
.receivers {
  width: 140px;
}
.file {
  width: 135px;
}
.status {
  width: 95px;
}
.path {
  width: calc(100% - 570px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.door {
  position: absolute;
  top: 20%;
  left: 50%;
  margin-left: -210px;
  z-index: 3;
  box-shadow: 0px 0px 5px 0px #aaaaaa;
  width: 420px;
  background-color: #fff;
  border-radius: 4px;
  padding: 40px;
}
.door .tr {
  padding: 5px 0;
  overflow: hidden;
}
.door .tr span {
  display: block;
  float: left;
  width: 140px;
  line-height: 30px;
}
.door .tr .set {
  width: calc(100% - 140px);
  padding-right: 10px;
}
.open {
  font-size: 20px;
  cursor: pointer;
  color: #409EFF;
  margin-top: 5px;
  float: left;
}
.door-path {
  max-width: 165px;
  float: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.cell:hover .operation {
  display: block;
}
.operation {
  display: none;
  position: absolute;
  background: #fff;
  top: 1px;
  right: 0;
  z-index: 2;
  width: 100px;
  height: 34px;
}
.operation i {
  font-size: 22px;
  cursor: pointer;
  margin: 7px 2px;
  color: #757575;
}
.operation i:hover {
  color: #212121;
}
.alarm-body {
  z-index: 3;
  background-color: rgba(0, 0, 0, .2);
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
}
.alarm {
  z-index: 3;
  background: #fff;
  position: absolute;
  left: 50%;
  top: 35%;
  margin-left: -180px;
  box-shadow: 0px 0px 5px 0px #aaaaaa;
  width: 360px;
  padding: 10px;
  border-radius: 2px;
}
.alarm .cell {
  text-align: center;
  width: 100%;
  margin-top: 10px;
}
</style>
